import { Controller } from "@hotwired/stimulus"

// 키오스크 노출 정보(설명/이미지) 저장 모달 전용 컨트롤러.
// 이 모달은 pos_controller.js의 item-editor 컨트롤러 바깥(#modals 프레임)에서 렌더링되므로
// item-editor#updateItem 을 직접 재사용할 수 없다. 저장 후에는 그 메서드와 동일하게
// "편집모드 유지" 플래그를 남기고 새로고침해서, item-editor#connect()가 편집모드(삭제/키오스크
// 등록 버튼 노출)를 모든 카드에 다시 적용하도록 한다.
export default class extends Controller {
  saved() {
    localStorage.setItem("item_editor_edit_mode", "true")
    window.location.reload()
  }

  // 노출 정보 폼 + 옵션 연결 폼을 순차 제출한다.
  // 첫 번째 폼(#kiosk_item_info_form) 제출이 끝나면 두 번째 폼(#option_link_form)을 제출한다.
  async saveAll(event) {
    event.preventDefault()
    if (!confirm("저장하시겠습니까?")) return

    const infoForm   = document.getElementById("kiosk_item_info_form")
    const optionForm = document.getElementById("option_link_form")

    if (infoForm) {
      await new Promise((resolve) => {
        const handler = () => { infoForm.removeEventListener("turbo:submit-end", handler); resolve() }
        infoForm.addEventListener("turbo:submit-end", handler)
        infoForm.requestSubmit()
      })
    }

    if (optionForm) {
      await new Promise((resolve) => {
        const handler = () => { optionForm.removeEventListener("turbo:submit-end", handler); resolve() }
        optionForm.addEventListener("turbo:submit-end", handler)
        optionForm.requestSubmit()
      })
    }

    this.saved()
  }
}
